module.exports = __webpack_public_path__ + "img/garage_original.6e0f6b0f.jpg";